import { render, staticRenderFns } from "./AscMxRecRecommendationTemplate.vue?vue&type=template&id=490cd70d&scoped=true&"
import script from "./AscMxRecRecommendationTemplate.vue?vue&type=script&lang=js&"
export * from "./AscMxRecRecommendationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecRecommendationTemplate.vue?vue&type=style&index=0&id=490cd70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cd70d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
